export const TEST_ID = 'droneHealthTab';

export const SECONDS_PER_HOUR = 3600;

export const EMPTY_VALUE = '—';
